import * as React from 'react'
import styled from 'styled-components'

import * as dateUtils from '@owl-nest/date'
import { COLORS, Pastille, styles as S } from '@ulule/owl-kit-components/next'

type EventBaseProps = {
  date: string
  title: string
  done?: boolean
  icon?: React.ReactNode
  backer?: React.ReactNode
  sponsor?: React.ReactNode
  tag?: React.ReactNode
}

export function EventBase({
  date,
  title,
  done,
  icon,
  backer,
  tag,
  sponsor,
}: EventBaseProps): React.ReactElement<EventBaseProps> {
  return (
    <Tiki done={done} icon={!!icon}>
      {icon && (
        <Pastille size="small" style={{ backgroundColor: COLORS.BRAND_ACCENT_GREEN }}>
          {icon}
        </Pastille>
      )}
      <S.heading.XXXXXS>{dateUtils.format(dateUtils.parseISO(date), 'dd MMMM yyyy')}</S.heading.XXXXXS>
      <Title>{title}</Title>
      {backer}
      {sponsor && <Sponsor>{sponsor}</Sponsor>}
      {tag}
    </Tiki>
  )
}

const Title = styled.div<{ done?: boolean }>`
  font-weight: bold;
  font-size: 18px;
  line-height: 25px;
  margin-bottom: 5px;
`
const Tiki = styled.div<{ done?: boolean; icon?: boolean }>`
  background-color: ${({ done }) => (done ? COLORS.SECONDARY_GREEN_800 : COLORS.PRIMARY_SAND)};
  margin: ${({ icon }) => (icon ? '70px auto 40px' : '40px auto')};
  text-align: center;
  max-width: 346px;
  padding-bottom: 8px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    z-index: -1;
    top: -40px;
    left: 50%;
    bottom: -40px;
    border: 1px dashed ${COLORS.GREY_SHADE_4};
    background: ${COLORS.PRIMARY_WHITE};
  }

  ${S.heading.XXXXXS} {
    padding-top: ${({ icon }) => (icon ? '41px' : '11px')};
    color: ${({ done }) => (done ? COLORS.PRIMARY_WHITE : COLORS.GREY_SHADE_2)};
  }

  ${Title} {
    color: ${({ done }) => (done ? COLORS.PRIMARY_WHITE : COLORS.GREY_SHADE_2)};
  }

  ${Pastille} {
    margin: 0 auto 5px;
    position: absolute;
    left: calc(50% - 30px);
    top: -30px;

    span {
      font-size: 35px;
    }
  }

  ${S.tag.Tag}, ${S.tag.RoleTag} {
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
  }
`

const Sponsor = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 11px;

  ${S.image.Avatar} {
    margin-right: 5px;
    flex: none;
  }
`
